import React, { Component } from 'react';
import { AppContext } from "./AppContext.jsx";
import  LoadingIcon2  from './components/ui/modals/product/extended-product-modal/ui/LoadingLoader/LoadingIcon2.jsx';

export default class AppLoadingIcon extends Component {
    render() {
        return this.context.showingLoadingIcon ? <LoadingIcon2 /> : <React.Fragment />;
    }
}

AppLoadingIcon.contextType = AppContext;